module.exports = __webpack_public_path__ + "img/logo-paldia.6957887e.png";